interface TwoColumnIconProps {
  size?: number;
}

const TwoColumnIcon: React.FC<TwoColumnIconProps> = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="8" height="16" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
      <rect x="13" y="4" width="8" height="16" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
    </svg>
  );
};

export default TwoColumnIcon;
